import { __awaiter, __generator } from "tslib";
import { useEffect, useState } from 'react';
import { loading, notAsked, success, failure, isSuccess } from '../libs/remoteData';
export function useService(asyncFunction, deps) {
    var _this = this;
    if (deps === void 0) { deps = []; }
    var _a = useState(notAsked), remoteData = _a[0], setRemoteData = _a[1];
    // Use another state variable to trigger effect on demand
    var _b = useState(0), reloadsCount = _b[0], setReloadsCount = _b[1];
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setRemoteData(loading);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, asyncFunction()];
                    case 2:
                        response = _a.sent();
                        setRemoteData(response);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setRemoteData(failure(err_1.response ? err_1.response.data : err_1.message));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        // eslint-disable-next-line
    }, deps.concat(reloadsCount));
    return [
        remoteData,
        {
            reload: function () { return setReloadsCount(function (count) { return count + 1; }); },
            set: function (dataOrFn) {
                if (typeof dataOrFn === 'function') {
                    setRemoteData(function (rd) { return (isSuccess(rd) ? success(dataOrFn(rd.data)) : rd); });
                }
                else {
                    setRemoteData(success(dataOrFn));
                }
            },
        },
    ];
}
//# sourceMappingURL=service.js.map